import React from "react";
import Carousel from "./Carousel";

export default function Portfolio() {
  return (
    <section className="section-portfolio">
      <div className="container">
        <div className="content">
          <h1 className="title">Portfolio.</h1>
          <Carousel />
        </div>
      </div>
    </section>
  );
}
